import theme from "@monorepo/styles/theme";
import { Box, styled } from "@mui/material";

export const SBanksListWrapper = styled(Box)(() => ({
  marginBottom: theme.spacing(4),
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  justifyContent: "stretch",
  rowGap: theme.spacing(2),
  columnGap: theme.spacing(2),
  [theme.breakpoints.up("sm")]: {
    gridTemplateColumns: " repeat(3, 1fr)",
    rowGap: theme.spacing(1),
    columnGap: theme.spacing(1),
  },
}));

interface ISBankListItem {
  selected: boolean;
}

export const SBanksListItem = styled(Box, { shouldForwardProp: (prop) => prop !== "selected" })<ISBankListItem>(
  ({ selected }) => ({
    display: "flex",
    alignItems: "center",
    border: `1px solid ${theme.palette.geyserGray.main}`,
    padding: theme.spacing(2, 1),
    columnGap: theme.spacing(1),
    borderRadius: theme.spacing(1),
    cursor: "pointer",
    textAlign: "left",
    borderColor: selected ? theme.palette.primary.main : theme.palette.geyserGray.main,
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(2, 3),
    },
    [theme.breakpoints.up("lg")]: {
      padding: theme.spacing(1, 3),
    },
  })
);

// export const FormWrapper = styled(Box)(() => ({
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "stretch",
//   }));
